import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getLiveEvents } from "../../services/liveevents";
import LiveEventsTable from "../../components/Tables/LiveEventsTable";

export const LiveEvents = () => {
  const { selectedClient } = useContext(AppContext);
  const [liveEvents, setLiveEvents] = useState([]);

  useEffect(() => {
    console.log("!!! FETCHING LIVE EVENTS");
    const fetchLiveEvents = async () => {
      try {
        setLiveEvents(
          await getLiveEvents(selectedClient.public_id ?? selectedClient.id)
        );
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchLiveEvents();
    }
    // eslint-disable-next-line
  }, [selectedClient]);

  return (
    <div>
      <LiveEventsTable
        liveEvents={liveEvents}
        onUpdated={(newLiveEvents) => {
          setLiveEvents(newLiveEvents);
        }}
      />
    </div>
  );
};

export default LiveEvents;
